import styled from 'styled-components';

export const Container = styled.div`
  height: 90vh;

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    animation: rotate 1s linear infinite;
    width: 5rem;
    height: 5rem;

    @keyframes rotate {
      100% {
        transform: rotate(360deg);
      }
    }
  }
`;
